import { forwardRef, type Ref, type SVGProps } from "react";

function SvgInfo(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#info_svg__a)">
        <circle cx={88} cy={60} r={50} stroke="url(#info_svg__b)" strokeWidth={20} />
        <path stroke="#0C1C43" strokeLinecap="square" d="M81.438 55.5H88v21.667" />
        <path
          fill="#0C1C43"
          stroke="#0C1C43"
          strokeWidth={0.25}
          d="M86.906 45.625h-.125v2.417h2.438v-2.417h-2.313Z"
        />
      </g>
      <defs>
        <linearGradient
          id="info_svg__b"
          x1={88}
          x2={88}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#FFE3C3" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="info_svg__a">
          <rect width={100} height={100} x={38} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgInfo);
export default ForwardRef;
